import {
  BooleanField,
  Datagrid,
  ImageField,
  List,
  NumberField,
  ReferenceField,
  RichTextField,
  TextField,
} from "react-admin";

export const LessonsList = () => (
  <List sort={{ field: "order", order: "ASC" }}>
    <Datagrid rowClick="edit">
      <ImageField
        source="preview"
        label="Прев'ю"
        sx={{
          "& img": {
            maxWidth: 50,
            maxHeight: 50,
            margin: "-1px!important",
          },
          "&": {
            background: "#fff",
            width: "50px",
            height: "50px",
            border: "1px solid #fbbf24",
          },
        }}
      />
      <TextField source="title" label="Назва" />
      <TextField source="slug" label="Слаг" />
      <ReferenceField source="course_id" reference="courses" label="Курс">
        <TextField source="title" />
      </ReferenceField>
      <TextField source="video" label="Посилання на відео" />
      <RichTextField source="description" label="Опис" />
      <BooleanField source="is_deleted" label="Деактивований" />
      <NumberField source="order" label="Порядок" defaultValue={0} />
    </Datagrid>
  </List>
);
